module.exports = __webpack_public_path__ + "img/employee-overview.b5db5570.png";